export default class Map {

	constructor() {

		this.settings = {
			$map: $('#map-canvas')
		};

		this.bindUIActions();

	}

	bindUIActions() {

		if(this.settings.$map.length){
			const latitude = document.querySelector('#lat');
			const longitude = document.querySelector('#long');

			if (latitude && longitude) {
				const lat = latitude.dataset.latitude;
				const lng = longitude.dataset.longitude;
				
				const myOptions = {
					center: new google.maps.LatLng(lat, lng),
					zoom: 16,
					mapTypeId: google.maps.MapTypeId.SATELLITE,
					disableDefaultUI: true,
				};

				const map = new google.maps.Map(document.getElementById('map-canvas'), myOptions);

                const marker = new google.maps.Marker({
					position: { lat: parseFloat(lat), lng: parseFloat(lng) },
					map: map,
					opacity: 1.0,
				});

			}
		}


	}
}

new Map();